<div #tabComponent class="tabs-container flex items-center">
  <div class="tag-box">
    <div class="flex flex-wrap gap-1 navigation-chip">
      <nav
        #tabNav
        mat-tab-nav-bar
        [tabPanel]="tabPanel"
        class="border-b-0 w-full !items-center"
        [attr.data-pagination-direction]="paginationDirection"
        [ngStyle]="{ height: isHidden ? '3rem' : null }"
      >
        <ng-template ngFor let-link [ngForOf]="filterTabs" let-index="index">
          <div
            *ngIf="!isHidden"
            mat-tab-link
            [disableRipple]="true"
            class="inline-block !mr-4 button-chip"
            [active]="selectedTabKey === link.selectKey"
            [tabIndex]="index"
            (click)="tabSelected(index, link.selectKey, $event, link.tabMenu)"
            (keydown.enter)="tabSelected(index, link.selectKey, $event, link.tabMenu)"
            spDataTestAttribute
            [cellValue]="link.text + 'Chip'"
          >
            <ng-container *ngIf="link.tabMenu; else tabWithNoMenu">
              <ng-container *ngIf="editingTab === link.key; else notCurrentTab">
                <span *ngIf="!toggleEditTab">{{ link?.text }}</span>
                <div *ngIf="toggleEditTab" class="form-field-wrapper" (keydown.enter)="saveTabName(index)" (keydown.escape)="exitRenameTab(index)">
                  <input
                    #renameInput
                    matInput
                    type="text"
                    [(ngModel)]="tabName"
                    (click)="$event.stopImmediatePropagation()"
                    (keydown.arrowleft)="$event.stopImmediatePropagation()"
                    (keydown.arrowright)="$event.stopImmediatePropagation()"
                  />
                  <div class="form-field-actions">
                    <button *ngIf="tabName" matSuffix mat-icon-button class="save-button icon-button-slim" aria-label="Save" (click)="saveTabName(index)">
                      <mat-icon class="material-icons-outlined">save</mat-icon>
                    </button>
                    <button matSuffix mat-icon-button aria-label="Clear" class="icon-button-slim" (click)="exitRenameTab(index)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </div>
              </ng-container>
              <ng-template #notCurrentTab>
                <span>{{ link?.text }}</span>
              </ng-template>
            </ng-container>
            <ng-template #tabWithNoMenu>
              <span>{{ link?.text }}</span
              ><span *ngIf="link?.count">&nbsp;({{ link?.count }})</span>
            </ng-template>

            <button
              #menuButton
              mat-icon-button
              class="menu-button icon-button-slim"
              i18n-matTooltip
              matTooltip="Tab options"
              [matMenuTriggerFor]="tabMenu"
              *ngIf="link.tabMenu"
              (click)="$event.stopImmediatePropagation()"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #tabMenu="matMenu">
              <button mat-menu-item (click)="renameTab(index)" [disabled]="toggleEditTab" *ngIf="link.tabType === 'dynamic'">
                <mat-icon class="material-icons-outlined">edit</mat-icon>
                <span i18n>Rename</span>
              </button>
              <button mat-menu-item (click)="pinTabToFront(index)" *ngIf="this.filterTabs[0].selectKey !== link.selectKey && (link.tabType === 'default' || link.tabType === 'dynamic')">
                <mat-icon class="material-icons-outlined">push_pin</mat-icon>
                <span i18n>Pin to front</span>
              </button>
              <button mat-menu-item (click)="unPinTab()" *ngIf="this.filterTabs[0].selectKey === link.selectKey && (link.tabType === 'default' || link.tabType === 'dynamic')">
                <mat-icon class="material-icons-outlined">push_pin</mat-icon>
                <span i18n>Unpin</span>
              </button>
              <button mat-menu-item (click)="deleteTab(index)" *ngIf="link.tabType === 'dynamic'">
                <mat-icon class="material-icons-outlined">delete</mat-icon>
                <span i18n>Delete filter</span>
              </button>
            </mat-menu>
          </div>
        </ng-template>
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    </div>
  </div>
  <button mat-icon-button class="button-icon-primary" (click)="addTabs()" i18n-matTooltip matTooltip="Add custom filters">
    <mat-icon class="material-icons-outlined">add</mat-icon>
  </button>
</div>
